import { useEffect, useLayoutEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import useMedia from "use-media";
import commonUtil from "../../../common/commonUtil";
import CommonValidation from "../../../common/commonValidation";
import { changeReserve, getAgreeInfo, getCourseInfo, getEsthetic, getMemberRelationList, getPropertyList, getServiceCheck, getShisetsu, getYoyakuKanoTimeInfo, setReserve } from "../../../const";
import MessageConst from '../../../const/messageConst';
import { useRtoaster } from "../../../hooks/useRtoaster";
import common from "../../../resources/js/common/common";
import { Button } from "../../atoms/button";
import { Label } from "../../atoms/label";
import { BreadCrumb } from '../../molecules/breadCrumb';
import { ErrorMassage } from "../../molecules/errorMassage";
import { EstheticInputList } from "../../molecules/estheticInputList";
import { MembershipFooterContainer } from '../common/membershipFooterContainer';
import './../../../resources_membership_hotel/css/hotel/inputUser.css';


let jikantai = "";

const EstheticInputUContainer = (props) => {
    const {
        state,
        login,
        estheRsvInfo,
        setEstheRsvInfo,
        estheticInfo,
        setEstheticInfo,
        serviceCheckInfo,
        setServiceCheckInfo,
        setLoginFlg,
        setPopupData,
        prevScreenInfo,
        onClickOpenCalendarWindow,
        onClickOpenPopupWindow
    } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);

    const history = useHistory();
    const store = useStore();
    const params = useParams();
    // const loginUserInfo = store.getState().login.loginUserInfo;
    const [linkList, setLinkList] = useState([]);
    const [agreementList, setAgreementList] = useState([]);
    const [relationList, setRelationList] = useState([]);
    
    const calendarFlg = state.calendarFlg;

    let reqShisetsuCd = "";


    // エラー情報
    const [errorInfo, setErrorInfo] = useState({ errorMessage: null, errorFlg: false, });
    const [temporaryErrorInfo, setTemporaryErrorInfo] = useState({ errorMessage: "", errorFlg: false, });
    const [flgList, setFlgList] = useState(false);

    // rtoasterタグ生成
    useRtoaster();

    useLayoutEffect(() => {
        // リフレッシュ対応
        // let state = store.getState().login;
        // let apiKey = null;
        // if (Object.keys(state).length !== 0) {
        //     apiKey = state.apiKey;
        // }
        // if (apiKey === null) {
        //     store.dispatch({ type: "CLEAR_STATE" });
        //     history.push("/reserve/login");
        // }
        // if (apiKey) {
        //     common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        // }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }
    
    useEffect(() => {
        // common.doPost(versionGetApi, {}, afterVerCheck);
        const backFlg = prevScreenInfo && (prevScreenInfo.currentPath.indexOf("hotel/facilityConfirmUser") != -1 && prevScreenInfo.prevPath.indexOf("hotel/facilityReserveComplete") == -1);
        if (backFlg && params?.shisetsuCd == estheticInfo?.shisetsuCd && params?.estheticCd == estheticInfo?.estheticCd) {
            // 戻る遷移時処理
            // 同意情報の設定
            if (estheRsvInfo.agreementList?.length > 0) {
                setAgreementList(estheRsvInfo.agreementList);
            } else if (estheticInfo) {
                let req = {
                    honkanShisetsuCd: estheticInfo.shisetsuCd,
                    shisetsuCd: estheticInfo.shisetsuCd,
                    cornerBunKbn: "2", /* 固定値 */
                    restaurantCd: estheticInfo.estheticCd
                }
                common.doPost(getAgreeInfo, req, afterGetAgreeInfo);
            }
            if (!params?.shisetsuCd) {
                setLinkList([{ path: "/reserve/top", label: "HOME" }]);
                setLoginFlg(true)
            }
        } else {
            setEstheRsvInfo({});
            if (params?.shisetsuCd) {
                // URL遷移時
                common.doPost(getShisetsu, {shisetsuCd: params.shisetsuCd}, afterGetShisetsuInfo);
            } else {
                setLoginFlg(true)
                setEstheRsvInfo({
                    loginFlg: true,
                });
            }
        }
        // window.scroll({ top: 0, behavior: 'smooth' })
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
        // 会員との関係一覧取得
        common.doPost(getMemberRelationList, {}, afterGetMemberRelationList);

        // プロパティ一覧取得
        common.doPost(getPropertyList, { propertyTypeList: ["SPAN_TIME"] }, afterGetPropertyList);
    }, [useMediaFlag]);

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    // 会員との関係一覧取得後処理
    const afterGetMemberRelationList = (res) => {
        let data = res.data;
        let errorMessage = "";
        let errorFlg = false;
        if (data.resultCode == 0) {
            setRelationList(commonUtil.getSelectList(data.relationList, "relationCd", "relationName", true, "選択する"));
        } else {
            // 一時エラー表示
            errorMessage = data.errorMessage;
            errorFlg = true;
        }
        setTemporaryErrorInfo({ errorMessage: errorMessage, errorFlg: errorFlg })
    }

    // サービスチェック取得処理
    const requestGetServiceCheck = (relation) => {
        if (!relation) {
            // 続柄が未選択時はAPIを呼び出さない
            return;
        }
        // サービスチェック取得
        const req = {
            keiyakuNo: estheticInfo.keiyakuNo,
            shisetsuCd: estheticInfo.shisetsuCd,
            riyoDate: estheRsvInfo.riyoDate,
            hakuCnt: 0,
            tsuzukigaraCd: relation,
            riyoKaiinkenSyubetCd: estheticInfo.riyoKaiinkenSyubetCd,
            roomTypeList: []
        }
        common.doPost(getServiceCheck, req, afterGetServiceCheck);
    }

    // サービスチェック取得後処理
    const afterGetServiceCheck = (res) => {
        let data = res.data;
        let errorMessage = "";
        let errorFlg = false;
        if (data.resultCode == 0) {
            setServiceCheckInfo({
                kozafurikaeKanoKbn: data.kozafurikaeKanoKbn,
                kozafurikaeKiyakuMongon: data.kozaMongon,
            });
        } else {
            // 一時エラー表示
            // errorMessage = data.errorMessage;
            // errorFlg = true;
        }
        setTemporaryErrorInfo({ errorMessage: errorMessage, errorFlg: errorFlg })
    }

    // プロパティリスト取得後処理(使用予定)
    const afterGetPropertyList = (res) => {
        let data = res.data;
        if (data) {
            if (data.propertyList && data.propertyList.length != 0) {
                let propertyList = data.propertyList;
                propertyList.map((value) => {
                    if (value.type === "SPAN_TIME" && value.propertyValue === "昼") {
                        jikantai = value.apiCallValue;
                        return;;
                    }
                })
            }
        } else {
            // エラー処理
        }
    }

    const afterGetShisetsuInfo = (res) => {
        const data = res.data;
        let newShisetsuInfo = {}
        if (data.resultCode === "0") {
            const shisetsu = res.data.shisetsuList[0];
            newShisetsuInfo = { honkanShisetsuCd: shisetsu.honkanShisetsuCd, shisetsuCd: shisetsu.shisetsuCd, shisetsuName: shisetsu.shisetsuName};
            reqShisetsuCd = shisetsu.honkanShisetsuCd;
        }
        common.doPostRef(getEsthetic, {shisetsuCd: params.shisetsuCd, estheticCd: params.estheticCd}, newShisetsuInfo, afterGetEstheInfo);
    }

    const afterGetEstheInfo = (res, ref) => {
        const data = res.data;
        if (data.resultCode === "0") {
            const esthe = res.data.estheticListInfo[0];
            setEstheticInfo({ ...estheticInfo,
                estheticCd: esthe.estheticCd,
                estheticName: esthe.estheticName,
                honkanShisetsuCd: ref.honkanShisetsuCd,
                shisetsuCd: ref.shisetsuCd,
                shisetsuName: ref.shisetsuName
            });
            setEstheRsvInfo({
                loginFlg: false,
            });
            let req = {
                honkanShisetsuCd: reqShisetsuCd,
                shisetsuCd: params.shisetsuCd,
                cornerBunKbn: "2", /* 固定値 */
                restaurantCd: esthe.estheticCd
            }
            common.doPost(getAgreeInfo, req, afterGetAgreeInfo);
        }
    }
    
    const afterGetCourseInfo = (res) => {
        const data = res.data;
        if (data.resultCode === "0") {
            setPopupData({
                honkanShisetsuCd: estheticInfo.honkanShisetsuCd,
                shisetsuCd: estheticInfo.shisetsuCd,
                estheticCd: estheticInfo.estheticCd,
                courseList: data.courseList,
                jikantai: jikantai
            })
        }
    }

    const afterGetYoyakuKanoTimeInfo = (res) => {
        const data = res.data;
        if (data.resultCode === "0") {
            setPopupData({
                honkanShisetsuCd: estheticInfo.honkanShisetsuCd,
                shisetsuCd: estheticInfo.shisetsuCd,
                estheticCd: estheticInfo.estheticCd,
                yoyakuKanoTimeInfoList: data.yoyakuKanoTimeInfoList,
                jikantai: jikantai
            })
        }
    }

    const afterGetAgreeInfo = (res) => {
        let data = res.data;
        if (data.resultCode == 0) {
            if (data.doiList && data.doiList.length != 0) { 
                let doiList = [];
                data.doiList.forEach(doiInfo => {
                    doiList.push({
                        title: doiInfo.doiTitle,
                        text: doiInfo.doiSetsumei,
                        link: doiInfo.doiSetsumeiURL,
                        checked: false
                    });
                })
                setAgreementList(doiList);
            }
        }
    }

    const handleRepresentInfo = (form) => {
        let input = document.getElementById(form).value;
        let newEstheRsvInfo = {...estheRsvInfo};
        if (form == "estheticNumber") {
            newEstheRsvInfo[form] = input.replace(/[^0-9]+/g,"")
        } else {
            newEstheRsvInfo[form] = input;
        }
        setEstheRsvInfo(newEstheRsvInfo);
    }

    // 入力内容変更(チェックボックス)
    const onChangeCheckBox = (name) => {
        let changeEle = document.getElementsByName(name);
        let changeValue = changeEle[0].checked;
        let newReserveInfo = {...estheRsvInfo};
        if (name == "otherMailFlg") {
            let confirmReserveEle = document.getElementsByName("kakuninMailKiboKbn");
            if (confirmReserveEle[0].checked) {
                newReserveInfo[name] = changeValue;
            }
            if (!changeValue) {
                newReserveInfo.confirmReserveMail = "";
            }
        } else {
            newReserveInfo[name] = changeValue;
        }
        if (name == "kakuninMailKiboKbn" && !changeValue) {
            newReserveInfo.confirmReserveMail = "";
            newReserveInfo.otherMailFlg = false;
        }
        setEstheRsvInfo(newReserveInfo);
    }

    // 同意チェック変更
    const onChangeAgreement = (doiIndex) => {
        let agreement = document.getElementById("agreement" + doiIndex).checked;
        let newAgreementList = [];
        agreementList.forEach((value) => {
            newAgreementList.push(value);
        });
        newAgreementList[doiIndex].checked = agreement;
        setAgreementList(newAgreementList);
    }

    // 会員様との関係変更
    const onChangeRelation = () => {
        let relation = document.getElementById("relation").value;
        if (relation) {
            setEstheRsvInfo({ ...estheRsvInfo, relationCd: relation })
            requestGetServiceCheck(relation);
        } else {
            setEstheRsvInfo({ ...estheRsvInfo, relationCd: relation, kozafurikaeFlg: false })
        }
    }

    // 同意情報表示
    const onClickDoiTitle = (doiIndex) => {
        let doiInfo = agreementList[doiIndex]
        setPopupData({
            doiInfo: doiInfo,
        });
        onClickOpenPopupWindow("doiInfo");
    }

    // サービス情報表示
    const onClickServiceLink = (serviceTitle, serviceText) => {
        setPopupData({
            serviceInfo: {
                serviceTitle: serviceTitle,
                serviceText: serviceText
            }
        });
        onClickOpenPopupWindow("serviceInfo");
    }

    const onClickCondition = (mode) => {
        if (mode === "course"){
            let req = {
                honkanShisetsuCd: estheticInfo.honkanShisetsuCd,
                shisetsuCd: estheticInfo.shisetsuCd,
                cornerBunKbn: "2", /* 固定値 */
                rstEstheCd: estheticInfo.estheticCd,
                jikantai: jikantai, /* 時間帯区分：昼固定 */
                riyoDate: estheRsvInfo.riyoDate
            }
            common.doPost(getCourseInfo, req, afterGetCourseInfo);
        } else if (mode === "yoyakuTime"){
            // 予約可能時間情報取得
            let reqCourseList = [];
            estheRsvInfo.courseList.forEach((value) => {
                reqCourseList.push({ 
                    courseCd: value.courseCd,
                    optionKbn: value.optionKbn,
                    hyojunTime: value.hyojunTime
                });
            })
            let req = {
                honkanShisetsuCd: estheticInfo.honkanShisetsuCd,
                shisetsuCd: estheticInfo.shisetsuCd,
                cornerBunKbn: "2", /* 固定値 */
                rstEstheCd: estheticInfo.estheticCd,
                riyoDate: estheRsvInfo.riyoDate,
                riyoNinzu: estheRsvInfo.riyoNinzu,
                courseList: reqCourseList,
                importedFlg: true
            }
            common.doPost(getYoyakuKanoTimeInfo, req, afterGetYoyakuKanoTimeInfo);
        }
        onClickOpenPopupWindow(mode)
    }

    // 「戻る」ボタン押下時
    const onClickBack = () => {
        history.push("/reserve/hotel/facilityReserve");
    }

    const getRadioValue = (name) => {
        let items = document.getElementsByName(name);
        let ret = "";
        items.forEach(value => {
            if (value.checked) {
                ret = value.value;
            }
        })
        return ret;
    }

    // 利用日カレンダーモーダル
    const onClickOpenCalendar = (startDate) => {
        let reqEstheticInfo = store.getState().estheticInfo;
        let reqReserveInfo = {...store.getState().estheRsvInfo};
        reqReserveInfo.riyoDate = startDate;
        // カレンダー空き情報取得
        onClickOpenCalendarWindow(reqEstheticInfo, reqReserveInfo);
    }

    // 予約チェック後処理
    const afterSetReserve = (res, ref) => {
        let errorMessage = "";
        let errorFlg = false;
        let data = res.data;
        if (data.resultCode == 0) {
            setEstheRsvInfo(ref);
            history.push("/reserve/hotel/facilityConfirmUser");
        } else {
            errorMessage = data.errorMessage;
            errorFlg = true;
        }
        setTemporaryErrorInfo({ errorMessage: errorMessage, errorFlg: errorFlg })
    }

    // 「確認画面へ」ボタン押下時
    const onClickCheckInput = () => {
        // 入力チェック
        let errorMessages = [];
        let flgList = {
            errorDoi: [],
            errorRiyoDate: false,
            errorMainCourse: false,
            errorOptionCourse: false,
            errorYoyakuTime: false,
            errorRepresentNameKana: false,
            errorRepresentName: false,
            errorMainPhoneKbn: false,
            errorRepresentTelNumber: false,
            errorReserverTelNumber: false,
            errorReserverMail: false,
            errorConfirmReserveMail: false,
            errorReserveFlg: false,
            errorReserveNo: false,
            errorBiko: false,
            errorEstheticNumber: false,
            validFlg: false,
            requireFlg: false
        };
        let representNameKana = document.getElementById("representNameKana").value;
        let representName = document.getElementById("representName").value;
        let mainPhoneNumber = document.getElementById("mainPhoneNumber").value;
        let reserverTelNumber = document.getElementById("reserverTelNumber")?.value;
        let reserverMail = document.getElementById("reserverMail")?.value;
        let relation = document.getElementById("relation") ? document.getElementById("relation").value : "";
        let kozafurikaeFlgEle = document.getElementsByName("kozafurikaeFlg");
        let kozafurikaeFlg = kozafurikaeFlgEle.length != 0 ? kozafurikaeFlgEle[0].checked : false;
        let biko = document.getElementById("biko").value;
        let kakuninMailKiboKbn = document.getElementsByName("kakuninMailKiboKbn")?.[0]?.checked;
        let confirmReserveMail = document.getElementById("confirmReserveMail")?.value;
        let otherMailFlgEle = document.getElementsByName("otherMailFlg");
        let otherMailFlg = otherMailFlgEle.length != 0 ? otherMailFlgEle[0].checked : "";
        let estheticNumber = document.getElementById("estheticNumber")?.value;

        // バリデーションチェック
        agreementList.forEach(doiInfo => {
            if (doiInfo.checked) {
                flgList.errorDoi.push(false);
            } else {
                flgList.requireFlg = true;
                flgList.errorDoi.push(true);
            }
        })
        if (CommonValidation.Require(estheRsvInfo.riyoDate)) {
            flgList.requireFlg = true;
            flgList.errorRiyoDate = true;
        }
        if (CommonValidation.Require(estheRsvInfo.yoyakuTime)) {
            flgList.requireFlg = true;
            flgList.errorYoyakuTime = true;
        }
        if (!estheRsvInfo.mainCourseList || estheRsvInfo.mainCourseList.length === 0) {
            flgList.requireFlg = true;
            flgList.errorMainCourse = true;
        }
        if (CommonValidation.Require(representNameKana)) {
            flgList.requireFlg = true;
            flgList.errorRepresentNameKana = true;
        } else if (CommonValidation.NameKanaSLC(representNameKana) || CommonValidation.OverMaxLength(representNameKana, 36)) {
            flgList.validFlg = true;
            flgList.errorRepresentNameKana = true;
        }
        if (CommonValidation.Require(representName)) {
            flgList.requireFlg = true;
            flgList.errorRepresentName = true;
        } else if (CommonValidation.ZenkakuAndSpace(representName) || CommonValidation.OverMaxLength(representName, 36)) {
            flgList.validFlg = true;
            flgList.errorRepresentName = true;
        }
        if (CommonValidation.Require(mainPhoneNumber)) {
            flgList.requireFlg = true;
            flgList.errorRepresentTelNumber = true;
        } else if (CommonValidation.Hankaku(mainPhoneNumber) || CommonValidation.OverMaxLength(mainPhoneNumber, 16)) {
            flgList.validFlg = true;
            flgList.errorRepresentTelNumber = true;
        }
        if (estheRsvInfo.loginFlg) {
            if (CommonValidation.Require(reserverTelNumber)) {
                flgList.requireFlg = true;
                flgList.errorReserverTelNumber = true;
            } else if (CommonValidation.Hankaku(reserverTelNumber) || CommonValidation.OverMaxLength(reserverTelNumber, 16)) {
                flgList.validFlg = true;
                flgList.errorReserverTelNumber = true;
            }
            if (CommonValidation.Require(relation)) {
                flgList.requireFlg = true;
                flgList.relation = true;
            }
            if (CommonValidation.Require(reserverMail)) {
                flgList.requireFlg = true;
                flgList.errorReserverMail = true;
            } else if (CommonValidation.NotMail(reserverMail) || CommonValidation.OverMaxLength(reserverMail, 51)) {
                flgList.validFlg = true;
                flgList.errorReserverMail = true;
            }
            if (kakuninMailKiboKbn) {
                if (otherMailFlg) {
                    if (CommonValidation.Require(confirmReserveMail)) {
                        flgList.requireFlg = true;
                        flgList.errorConfirmReserveMail = true;
                    } else if (CommonValidation.NotMail(confirmReserveMail) || CommonValidation.OverMaxLength(confirmReserveMail, 51)) {
                        flgList.validFlg = true;
                        flgList.errorConfirmReserveMail = true;
                    }
                } else {
                    confirmReserveMail = reserverMail;
                }
            }
        }
        if (!CommonValidation.Require(biko) && CommonValidation.OverMaxLengthCareHalfHull(biko, 667)) {
            flgList.validFlg = true;
            flgList.errorBiko = true;
        }
        if (CommonValidation.Require(estheticNumber)) {
            flgList.validFlg = true;
            flgList.errorEstheticNumber = true;
        }
        if (flgList.requireFlg) {
            errorMessages.push(MessageConst.REQUIRE_INPUT_ERROR);
        }
        if (flgList.validFlg) {
            errorMessages.push(MessageConst.VALID_INPUT_ERROR);
        }
        if (errorMessages.length > 0) {
            window.scroll({ top: 0, behavior: 'smooth' })
            setErrorInfo({ errorMessage: errorMessages, errorFlg: true });
            setFlgList(flgList);
        } else {
            let gairaiList = [{
                riyoDate: estheRsvInfo.riyoDate,
                jikantaiKbn: "1",
                rstEstheCd: estheticInfo.estheticCd,
                cornerBunKbn: "2",
                startTime: estheRsvInfo.yoyakuTime,
                adultCnt: 1,
            }];

            let courseList = estheRsvInfo.mainCourseList;
            if (estheRsvInfo.optionCourseList?.length > 0) {
                courseList = courseList.concat(estheRsvInfo.optionCourseList)
            }
            let gairaiCourseList = [];
            courseList.forEach(value => {
                gairaiCourseList.push({
                    riyoDate: estheRsvInfo.riyoDate,
                    jikantaiKbn: "1",
                    rstEstheCd: estheticInfo.estheticCd,
                    gairaiCourseCd: value.courseCd,
                    gairaiCourseName: value.courseName,
                    targetCnt: 1
                });
            });
            let newEstheRsvInfo = {
                ...estheRsvInfo,
                keiyakuNo: estheticInfo.keiyakuNo ? estheticInfo.keiyakuNo : "0099999993",
                riyoKaiinkenSyubetCd: estheticInfo.riyoKaiinkenSyubetCd ? estheticInfo.riyoKaiinkenSyubetCd : "1",
                honkanShisetsuCd: estheticInfo.honkanShisetsuCd,
                shisetsuCd: estheticInfo.shisetsuCd,
                shisetsuName: estheticInfo.shisetsuName,
                estheticCd: estheticInfo.estheticCd,
                estheticName: estheticInfo.estheticName,
                agreementList: agreementList,
                riyoNinzu: estheRsvInfo.mainCourseList.length,
                daihyouNameKana: representNameKana,
                daihyouName: representName,
                mainPhoneKbn: "5",
                mainPhoneNumber: mainPhoneNumber,
                contactPhoneNumber: reserverTelNumber,
                contactMailAddress: estheRsvInfo.loginFlg ? reserverMail : "xxxx@rttest.com",
                relation: relationList.find(value => value.id == relation).value,
                relationCd: relation,
                kozafurikaeDispFlg: kozafurikaeFlgEle.length != 0,
                kozafurikaeFlg: kozafurikaeFlg,
                biko: biko,
                kakuninMailKiboKbn: kakuninMailKiboKbn ? "1" : "0",
                confirmReserveMail: estheRsvInfo.loginFlg ? confirmReserveMail : "xxxx@rttest.com",
                estheticNumber: estheRsvInfo.estheticNumber,
                gairaiList: gairaiList,
                gairaiCourseList: gairaiCourseList,
                gairaiRsvKbn: estheRsvInfo.loginFlg ? "2" : "3"
            };

            let req = {
                shisetsuCd: newEstheRsvInfo.shisetsuCd,
                shisetsuName: newEstheRsvInfo.shisetsuName,
                keiyakuNo: newEstheRsvInfo.keiyakuNo, 
                riyoKaiinkenSyubetCd: newEstheRsvInfo.riyoKaiinkenSyubetCd, 
                registFlg: false,
                riyoDate: newEstheRsvInfo.riyoDate,
                daihyouNameKana: newEstheRsvInfo.daihyouNameKana,
                daihyouName: newEstheRsvInfo.daihyouName,
                mainPhoneKbn: newEstheRsvInfo.mainPhoneKbn,
                mainPhoneNumber: newEstheRsvInfo.mainPhoneNumber,
                contactPhoneNumber: newEstheRsvInfo.contactPhoneNumber,
                contactMailAddress: newEstheRsvInfo.contactMailAddress,
                relationCd: relation,
                kozafurikaeFlg: kozafurikaeFlg,
                biko: newEstheRsvInfo.biko,
                kakuninMailKiboKbn: newEstheRsvInfo.kakuninMailKiboKbn,
                kakuninMailAddress: newEstheRsvInfo.confirmReserveMail,
                gairaiList: gairaiList,
                gairaiCourseList: gairaiCourseList,
                allergyKbn: "2", // 2:無し 固定
                hakuCnt: 0,
                carCnt:0,
                importedFlg: true, /* 外来フラグ　固定値 */
                changeFlg: estheticInfo.changeFlg,
                yoyakuNo: estheRsvInfo.yoyakuNo ? estheRsvInfo.yoyakuNo : "",
                gairaiRsvKbn: newEstheRsvInfo.gairaiRsvKbn,
                estheticNumber: newEstheRsvInfo.estheticNumber,
            };

            if (estheticInfo.changeFlg) {
                common.doPostRef(changeReserve, req, newEstheRsvInfo, afterSetReserve);
            } else {
                common.doPostRef(setReserve, req, newEstheRsvInfo, afterSetReserve);
            }
        }      
    }

    return (
        <div className="userInputInnerWrapper">
            <BreadCrumb
                breadCrumbStyle={isWideTablet ? { display: "none" } : styles.breadCrumb}
                linkStyle={styles.link}
                linkList={linkList}
                lastLabel="お客様情報入力"
                lastLabelClassName="lastLabel"
            />
            <div style={isWideTablet ? styles.breadCrumb2 : { display: "none" }}></div>
            <div className="reserveInputWrapper">
                <div style={errorInfo.errorFlg ? styles.errorDiv : { display: "none" }}>
                    <ErrorMassage style={styles.errorMassage} data={errorInfo.errorMessage} />
                </div>
                <div className={"reserveInfo"} style={styles.userInput}>
                    <Label
                        label={"ご予約内容"}
                        className="titleLabel"
                    />
                    <div className={"reserveInfoContentBlock"}>
                        <div className="reservationContent lastContent">
                            <Label
                                label="館内施設名"
                                className="reserveInfoTitleGray"
                            />
                            <Label
                                label={estheticInfo.shisetsuName + "\n" + estheticInfo.estheticName}
                                className="reserveInfoContentLabel"
                            />
                        </div>
                    </div>
                </div>
                {/* エステ入力フォーム */}
                <EstheticInputList
                    titleClassName="titleLabel"
                    flgList={flgList}
                    estheticInfo={estheticInfo}
                    agreementList={agreementList}
                    serviceCheckInfo={serviceCheckInfo}
                    relationList={relationList}
                    onChangeAgreement={onChangeAgreement}
                    estheRsvInfo={estheRsvInfo}
                    setEstheRsvInfo={setEstheRsvInfo}
                    onChangeCheckBox={onChangeCheckBox}
                    onChangeRelation={onChangeRelation}
                    handleRepresentInfo={handleRepresentInfo}
                    onClickDoiTitle={onClickDoiTitle}
                    onClickServiceLink={onClickServiceLink}
                    onClickCondition={onClickCondition}
                    responsiveFlg={isWideTablet}
                    loginFlg={estheRsvInfo?.loginFlg}
                    onClickOpenPopupWindow={onClickOpenPopupWindow}
                    onClickOpenCalendarWindow={onClickOpenCalendar}
                    setPopupData={setPopupData}
                />
            </div>
            <div className="btnToConfirmWrapper">
                {estheRsvInfo?.loginFlg ?
                    <div className="confirmboxWrap">
                        <Button buttonText="戻る" className="btnBack btnSpStyle" onClick={onClickBack} buttonClassName="serachBtnText" />
                        <Button buttonText="確認画面へ" className="btnToConfirm btnSpStyle2" onClick={onClickCheckInput} buttonClassName="serachBtnText" />
                    </div>
                    :
                    <div className="confirmboxWrapCenter">
                        <Button buttonText="確認画面へ" className="btnToConfirmNoMargin btnSpStyle2" onClick={onClickCheckInput} buttonClassName="serachBtnText" />
                    </div>
                }
            </div>
            <div className="backTopInput">
                {/* <Link to={"/reserve/hotel/search"} style={styles.bottomLink}>ホテル検索TOPへ戻る</Link> */}
                <div style={temporaryErrorInfo.errorFlg ? styles.errorDiv : { display: "none" }}>
                    <ErrorMassage style={styles.errorMassage} data={[temporaryErrorInfo.errorMessage]} />
                </div>
            </div>
            <div style={styles.footer}>
                <MembershipFooterContainer className={"reservationResultFooterBase"} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        login: state.login,
        estheRsvInfo: state.estheRsvInfo,
        estheticInfo: state.estheticInfo,
        serviceCheckInfo: state.serviceCheckInfo,
        prevScreenInfo: state.prevScreenInfo
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setEstheRsvInfo: (item) => {
            dispatch({ type: "ESTHE_RSV_INFO", payload: { estheRsvInfo: item } })
        },
        setEstheticInfo: (item) => {
            dispatch({ type: "ESTHETIC_INFO", payload: { estheticInfo: item } })
        },
        setServiceCheckInfo: (item) => {
            dispatch({ type: "SERVICE_CHECK_INFO", payload: { serviceCheckInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(EstheticInputUContainer);

const styles = {
    breadCrumb: {
        display: "flex",
        color: "white",
        padding: "8px 0px 30px 0px",
    },
    breadCrumb2: {
        marginBottom: "30px",
    },
    userInput: {
        display: "block",
        flexWrap: "wrap",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    bottomLink: {
        padding: "3px",
        color: "#696969",
        fontSize: "small",
    },
    errorMassage: {
        display: "inline-block",
        textAlign: "left",
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        border: 0,
        fontWeight: "bold"
    },
}